import React from 'react';
interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'white';
}
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'primary'
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };
  const colorClasses = {
    primary: 'text-purple-600',
    white: 'text-white'
  };
  return <div className={`animate-spin rounded-full border-2 border-t-transparent ${sizeClasses[size]} ${colorClasses[color]}`} role="status" aria-label="جاري التحميل" data-id="element-2263">
      <span className="sr-only" data-id="element-2264">جاري التحميل...</span>
    </div>;
};